import React from 'react';
import Svg from "../Svg";

const TrackTypeBlueIcon = props => (
   <Svg width="30px" height="30px" viewBox={"30 30"}>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
         <g id="MapStatus-06-12--map" transform="translate(-25.000000, -502.000000)">
            <g>
               <g transform="translate(24.000000, 453.000000)">
                  <g transform="translate(1.000000, 49.000000)">
                     <g>
                        <circle id="Oval" fill="#A7CFFB" fillRule="evenodd" cx="15" cy="15" r="15"/>
                        <circle id="Oval-Copy-3" fill="#007AFF" fillRule="evenodd" cx="15" cy="15" r="11.6666667"/>
                        <text id="1C" fontFamily="MapFont, Open Sans" fontSize="14" fontWeight="normal"
                              fill="#FFFFFF">
                           <tspan x="8.27311198" y="19.0833333">1C</tspan>
                        </text>
                     </g>
                  </g>
               </g>
            </g>
         </g>
      </g>
   </Svg>
);

export default TrackTypeBlueIcon;
